<template>
<div>

 <div class="form-row">
    <div class="col-md-auto mb-3">
    <label for="validationDefault03">Sconto 1</label>
           <div class="input-group">
      <div class="input-group-prepend">
          <div class="input-group-text">%</div>
        </div>
      <input  ref="input" @input="setDiscount()" step="0.01" v-model="discount1" type="number" class="form-control" placeholder="Sconto 1" name="discount1" id = "discount1" >
      
                  

     </div>


      
    </div>
    <div class="col-md-auto mb-3">
       <label for="validationDefault03">Sconto 2</label>
          <div class="input-group">
      <div class="input-group-prepend">
          <div class="input-group-text">%</div>
          <input @input="setDiscount()" step="0.01" v-model="discount2" type="number" class="form-control " placeholder="Sconto 2" name="discount2" id = "discount2">
         
                  
      </div>
     </div>  
    </div>
    <div class="col-md-auto mb-3">
      <label for="validationDefault03">Sconto 3</label>
       <div class="input-group">
      <div class="input-group-prepend">
          <div class="input-group-text">%</div>
    <input @input="setDiscount()" step="0.01" v-model="discount3" type="number" class="form-control " placeholder="Sconto 3" name="discount3" id = "discount3">
      </div>

    </div>
    </div>
  </div>





</div>





</template>

<script>


  export default {
    props:['discounts','vfocus'],
     components: {},
    data () {
      return {
        discount1 : 0,
        discount2 : 0,
        discount3 : 0
      }
    },

     directives: 
    {
      focus: {
      // directive definition
      inserted: function (el) 
      {
       
          el.focus() 
       

        
      }
      }
    },
    mounted()
    {
      
     
      if(this.discounts)
      {
          this.discounts.forEach(item => {
          if(item.order_by == 1)
          { 
            if(item.discount)
            {
              this.discount1 = item.discount
            }
          }
          if(item.order_by == 2)
          {
            if(item.discount)
            {
              this.discount2 = item.discount
            }
          }
          if(item.order_by == 3)
          {
            if(item.discount)
            {
              this.discount3 = item.discount
            }
          }
        })
    }
    },
    created () 
    {
     
     //this.$refs.input.focus()
     this.$nextTick(() => {
         if(this.vfocus)
         {
          this.$refs.input.focus()
         }
      })

     
    },
    methods: 
    {
    
    
      setDiscount()
      {
        let discount1 = this.discount1
        let discount2 = this.discount2
        let discount3 = this.discount3
        

        if(discount1.length == 0)
        {
          discount1 = 0
        }
        if(discount2.length == 0)
        {
          discount2 = 0
        }
        if(discount3.length == 0)
        {
          discount3 = 0
        }
        
        this.$emit('update',discount1,discount2,discount3)
      }

      
      

      
      

    }
  }
</script>
<style scoped>


</style>
